var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 20,
    fill: "#96CD00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    stroke: "#46484B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0008 12C21.9722 12 19.5083 14.4551 19.5083 17.4731C19.5083 20.4901 21.9722 22.9442 25.0008 22.9442C28.0304 22.9442 30.4943 20.4901 30.4943 17.4731C30.4943 14.4551 28.0304 12 25.0008 12ZM25.0009 13.9412C26.9611 13.9412 28.5536 15.5249 28.5536 17.4734C28.5536 19.4269 26.9611 21.0038 25.0009 21.0038C23.0417 21.0038 21.4492 19.4269 21.4492 17.4734C21.4492 15.5249 23.0417 13.9412 25.0009 13.9412Z",
    fill: "#46484B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 24.3794C22.3498 24.3794 15.0552 25.8088 14.9961 30.4105L14.9893 31.015L15.326 31.5167C17.4958 34.7492 21.1125 36.6773 25 36.6773C28.8884 36.6773 32.5041 34.7492 34.6749 31.5167L35.0126 31.0121L35.0048 30.4056C34.934 25.8078 27.6472 24.3794 25 24.3794ZM25.0001 26.3206C27.6813 26.3206 33.0234 27.783 33.0642 30.4351C31.3233 33.027 28.3665 34.7369 25.0001 34.7369C21.6338 34.7369 18.6779 33.027 16.937 30.4351C16.971 27.783 22.3199 26.3206 25.0001 26.3206Z",
    fill: "#46484B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.642d21ee68f462fa61eaaf031686feaa.svg";
export { ForwardRef as ReactComponent };